<template>
  <header class="employers-lt-page-header  container">
    <div class="employers-lt-page-header__content  container-inner">
      <a :href="getRoute({name: 'about'})"
         class="employers-lt-page-header__logo  main-logo">
        <picture class="main-logo__img-wrap">
          <source v-if="logoHWebp"
                  :srcset="logoHWebp"
                  type="image/webp">
          <img class="main-logo__img main-logo__img--horizontal"
               :src="logoH"
               :alt="createAltMixin('Logo')"
               :title="createTitleMixin('Logo')">
        </picture>
      </a>

      <nav class="employers-lt-page-header__menu  d-sm-none">
        <a :href="getRoute({name: 'about'})"
           class="base-link employers-lt-page-header__menu-link">
          <BaseSvg name="ico-question"
                   width="1.5rem"
                   height="1.5rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ section.link_1 }}</span>
        </a>
        <a :href="getRoute({name: 'vacancies'})"
           class="base-link employers-lt-page-header__menu-link">
          <BaseSvg name="ico-list-2"
                   width="1.7rem"
                   height="1.5rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ section.link_2 }}</span>
        </a>
      </nav>

      <a href="#employers-lt-order"
         @click.prevent="$scrollTo('#employers-lt-order', {offset: 0})"
         class="employers-lt-page-header__btn  base-btn  base-btn--blue  d-sm-none">
        {{ section.button }}
      </a>

      <button type="button"
              key="mob-menu"
              @click.prevent="onMobMenuToggle"
              :class="isMobMenuOpen ? '_open' : null"
              class="main-header__buttons-item main-header__mob-btn base-btn d-none d-sm-inline-flex">
        <transition name="fade">
          <BaseSvg v-if="isMobMenuOpen"
                   key="1"
                   name="ico-close"
                   width="2.1rem"
                   height="1.4rem"/>
          <BaseSvg v-else
                   key="2"
                   name="ico-burger"
                   width="2.1rem"
                   height="1.4rem"/>
        </transition>
      </button>
    </div>

    <transition name="fade">
      <EmployersLTPageHeaderMobMenu v-if="isMobMenuOpen"
                                    @close="isMobMenuOpen = false"
                                    :section="section"
                                    :getRoute="getRoute"/>
    </transition>
  </header>
</template>

<script>
  import EmployersLTPageHeaderMobMenu from '@/components/employersLTPage/EmployersLTPageHeaderMobMenu'

  export default {
    name: 'EmployersLTPageHeader',
    components: {
      EmployersLTPageHeaderMobMenu
    },
    props: {
      section: Object
    },
    data() {
      return {
        isMobMenuOpen: false
      }
    },
    computed: {
      currentLocale() {
        return this.$store.state.currentLocale
      },
      logoH() {
        return globalConfigs && globalConfigs.header.logo_horizontal || 'https://api.jobian.com/storage/settings/January2020/rvSqR1keRQQmC4S8UVCt.png'
      },
      logoHWebp() {
        return globalConfigs && globalConfigs.header.logo_horizontal_webp
      }
    },
    methods: {
      onMobMenuToggle() {
        this.isMobMenuOpen = !this.isMobMenuOpen
      },
      getRouteLang() {
        if (this.currentLocale === 'ua') {
          return 'en'
        } else {
          return this.currentLocale
        }
      },
      getRoute(route) {
        if (!route.params) {
          route.params = {}
        }

        route.params.lang = this.getRouteLang()

        const matchedRoute = this.$router.match(route)

        return matchedRoute.fullPath
      },
      onRouteClick() {
        this.$store.dispatch('changeCurrentLocale', this.getRouteLang())
      }
    }
  }
</script>

<style lang="less">

</style>
